import React, { useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import {
  addHighlightedSkillAPI,
  addSelfReportedSkillAPI,
  getUserId,
  GLOBAL_COLORS,
  parseHighlightedSkills,
  parseSelfReportedSkills,
  skillsSearchAPI,
} from '../../../hooks';
import './AddSkillModal.css';
import { LiaTimesSolid } from 'react-icons/lia';
import SelectedSkills from '../../../components/SelectedSkills/SelectedSkills';
import SkillSearchResults from '../../../components/SkillSearchResults/SkillSearchResults';

export const AddSkillModal = (props) => {
  const { t } = useTranslation('library');

  const [selectedSkills, setSelectedSkills] = useState([]);
  const [searchedSkills, setSearchedSkills] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const debounceTimeout = useRef(null);
  const [starCount, setStarCount] = useState(1)

  const handleInputChange = (e) => {
    e.preventDefault();
    const inputValue = e.target.value;
    setSearchTerm(inputValue);

    if (inputValue.trim() === '') {
      setSearchedSkills([]);
      return;
    }

    if (debounceTimeout.current) {
      clearTimeout(debounceTimeout.current);
    }

    const delay = 400;
    debounceTimeout.current = setTimeout(() => {
      skillsSearchAPI(inputValue, (data) => {
        const existingSkillNames = props.skillsData
          .filter((skill) => skill && skill.name && typeof skill.name === 'string')
          .map((skill) => skill.name.toLowerCase());

        const filteredResults = (data?.results || []).filter(
          (skill:any) =>
            skill &&
            skill.data &&
            skill.data.name &&
            typeof skill.data.name === 'string' &&
            !existingSkillNames.includes(skill.data.name.toLowerCase())
        );
        setSearchedSkills(filteredResults);
      });
    }, delay);
  };

  const formatHighlightedSkillData = (skill) => {
    const skillList = props.skillsData.map((skill) => skill.name);
    skillList.push(...selectedSkills.map((skill) => skill.name));

    return {
      user_id: getUserId(),
      skills: skillList,
    };
  };

  const handleAddDesiredSkill = (skill) => {
      addHighlightedSkillAPI(
        JSON.stringify(formatHighlightedSkillData(skill)),
        function (data) {
          handleCloseModal();
          props.refreshSkills(parseHighlightedSkills(data));
        }
      );
  };

  const handleSkillSelect = (skill) => {
    if (props.skillType === 'selfReported') {
    setSelectedSkills([skill])
    setStarCount(starCount)
      handleCloseModal()
      props.handleSkillClick({name:skill?.name, starCount:1, skillType: props?.skillType})
    }
    else {
      const skillIndex = selectedSkills.findIndex(
      (selectedSkill) => selectedSkill.id === skill.id
    );
    if (skillIndex === -1) {
      setSelectedSkills([...selectedSkills, skill]);
    } else {
      const newSelectedSkills = [...selectedSkills];
      newSelectedSkills.splice(skillIndex, 1);
      //setSelectedSkills((old)=>(old.filter((singleSkill)=>singleSkill.id===skill.id)));
    }
    }
  };

  const handleCloseModal = () => {
    setSearchedSkills([]);
    setSelectedSkills([]);
    setSearchTerm('');
    props.closeModal();
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
  };

  const handleRemoveSelectedSkill = (skillToRemove) => {
    setSelectedSkills((prev) =>
      prev.filter((skill) => skill.id !== skillToRemove.id)
    );
  };

  return (
    <div className="popup_div active">
      <div className="popup_cont sk">
        <div className="add_skill_popup active">
          <div className="div-block-520">
            <div>{t('Add Skill')}</div>
            <LiaTimesSolid
              color={GLOBAL_COLORS.icon_color}
              className={'cancel_add_skill'}
              style={{
                height: '16px',
                width: '16px',
              }}
              onClick={handleCloseModal}
              data-testid="close-modal-button"
            />
          </div>
          <div className="div-block-525">
            <div className="div-block-469 sk_s">
              <div className="form-block-15 s_skill w-form">
                <form
                  onSubmit={handleFormSubmit}
                  id="email-form"
                  name="email-form"
                  data-name="Email Form"
                  method="get"
                  className="form-10"
                  data-wf-page-id="6596f6f119932dba27256924"
                  data-wf-element-id="f31e1962-462b-8b0d-0045-72a4bb8371da"
                  aria-label="Email Form"
                >
                  <div className="div-block-410">
                    <img
                      src="https://assets-global.website-files.com/6596e21ac435cac3c66baad8/6596e21ac435cac3c66bacc8_magnifying-glass.png"
                      loading="lazy"
                      alt=""
                      className="image-164"
                    />
                  </div>
                  <input
                    style={{ width: '100%' }}
                    className="text-field-14 n_text w-input"
                    name="searchSkills"
                    data-name="searchSkills"
                    placeholder={t('Search for skills')}
                    type="text"
                    id="searchSkills"
                    value={searchTerm}
                    onChange={handleInputChange}
                    required
                  />
                </form>
                <SelectedSkills
                  selectedSkills={selectedSkills}
                  onRemove={handleRemoveSelectedSkill}
                />
                <SkillSearchResults
                  searchedSkills={searchedSkills}
                  handleSkillSelect={handleSkillSelect}
                />
                <div
                  className="w-form-done"
                  tabIndex={-1}
                  role="region"
                  aria-label={'Email Form success'}
                >
                  <div>
                    {t('Thank you! Your submission has been received!')}
                  </div>
                </div>
                <div
                  className="w-form-fail"
                  tabIndex={-1}
                  role="region"
                  aria-label={'Email Form failure'}
                >
                  <div>
                    {t('Oops! Something went wrong while submitting the form.')}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="popup-f">
            <div
              className="div-block-475 confirm_add_skill"
              onClick={handleAddDesiredSkill}
            >
              <div className="text-block-284 add_skill_text">
                {t('Add Skill')}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
